import React, { useEffect, useState } from "react";
import { fetchReportGoals } from "../../../services/httpClient";
import { SingleCardMetric } from "../ui/SingleCardMetric";
import { formatDateTimeToLocal } from "../../../helpers/date";

interface GoalsOutstandingMetricState {
  data?: any[];
  readOnly?: boolean;
  setSelectedData: (data: any[] | null) => void;
  setDataHeaders: (data: any[] | null) => void;
  active?: boolean;
  useDatePicker?: boolean;
  startDate?: string;
  endDate?: string;
  onHandleClick?: any;
}

export const GoalsOutstandingMetric = ({
  data,
  readOnly = true,
  setSelectedData,
  setDataHeaders,
  active,
  useDatePicker = false,
  startDate,
  endDate,
  onHandleClick,
}: GoalsOutstandingMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [outstanding, setOutstanding] = useState<any[]>();

  const tableHeaders = [
    { label: "Case Name", key: "case_name" },
    { label: "Goal", key: "goal_name" },
    { label: "Assigned To", key: "subject.name" },
    { label: "Created", key: "created_at_formatted" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (data || data === 0) {
        setOutstanding(data);
        setIsLoading(false);
      } else {
        //default dates
        const starting = new Date();
        starting.setDate(starting.getDate() - 365);
        var start = starting.toISOString().slice(0, 10);
        var end = new Date().toISOString().slice(0, 10);
        if (useDatePicker) {
          start = startDate ?? start;
          end = endDate ?? end;
        }
        await getGoalData(start!, end!);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [data, startDate, endDate]);

  const getGoalData = async (start: string, end: string) => {
    fetchReportGoals(start, end)
      .then((res: any) => {
        const goals = res[0].data;
        const sortedGoals = goals.sort((a: any, b: any) => (a.completed_at < b.completed_at ? 1 : -1));
        sortedGoals.forEach((goal: any) => {
          if (goal?.completed_at) {
            const localDateTime = formatDateTimeToLocal(goal.completed_at);
            goal.completed_at_formatted = localDateTime.date + " " + localDateTime.time;
          }
          if (goal?.created_at) {
            const localDateTime = formatDateTimeToLocal(goal.created_at);
            goal.created_at_formatted = localDateTime.date + " " + localDateTime.time;
          }
        });
        const outstanding = sortedGoals.filter((g: any) => !g.completed_at);
        setOutstanding(outstanding);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const onViewDetails = () => {
    if (!active) {
      setSelectedData(outstanding || null);
    } else {
      setSelectedData(null);
    }

    setDataHeaders(tableHeaders);
    onHandleClick();
  };

  if (readOnly) {
    return <SingleCardMetric title={"Goals Outstanding"} total={outstanding?.length} isLoading={isLoading} />;
  } else {
    return (
      <SingleCardMetric
        title={"Goals Outstanding"}
        total={outstanding?.length}
        onHandleClick={onViewDetails}
        cursor={true}
        active={active}
        isLoading={isLoading}
      />
    );
  }
};
